import React, { ReactElement } from 'react';
import { AppFeatures, Features } from '../helpers/PermissionUtility-types';
import { Outlet } from 'react-router-dom';
import FeatureFlagged from './FeatureFlagged';
import { canIUse } from '../helpers/PermissionUtility';

export type FeatureFlaggedLayoutProps = {
  feature: AppFeatures | Features;
  upgradeRequired?: boolean;
  children?: ReactElement;
};

/** A layout that can be used to control a group of  */
export default function FeatureFlaggedLayout({ feature, upgradeRequired, children }: FeatureFlaggedLayoutProps) {
  if (children && !canIUse(feature)) {
    return children;
  }

  return (
    <FeatureFlagged feature={feature} upgradeRequired={upgradeRequired}>
      <Outlet />
    </FeatureFlagged>
  );
}
